var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.18182V5.12581M16 2.18182V5.12581M20.5909 8.89202H3.09091M8.31818 11.9951H10.1136V18.6191M12.6263 11.9951H13.7773C14.6911 11.9951 15.4318 12.7358 15.4318 13.6496V13.6496C15.4318 14.551 14.7102 15.2865 13.809 15.3038L13.6364 15.3071M12.6263 18.6191H13.7767C14.6908 18.6191 15.4318 17.878 15.4318 16.9639V16.9639C15.4318 16.057 14.702 15.3189 13.7951 15.3088L13.6364 15.3071M13.6364 15.3071H13.4445M16 3.65381C19.33 3.83045 21 5.07674 21 9.68898V15.7536C21 19.7967 20 21.8182 15 21.8182H9C4 21.8182 3 19.7967 3 15.7536V9.68898C3 5.07674 4.67 3.84027 8 3.65381H16Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCal);
export default __webpack_public_path__ + "static/media/cal.30cab46ea8aa101b057d77b6ef6093ce.svg";
export { ForwardRef as ReactComponent };